import React, { useState } from 'react';
import classNames from 'classnames';

import { Button, ClickAwayListener, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { withStyles } from '@material-ui/styles';
import styles from './styles';
import { muiTheme } from '../../../theme';

import { AppsIcon, ArrowRightIcon, UserIcon } from '../../common/Icon';

import { appDropdownLinks, manageDropdownLinks } from '../../../constants/navigation';
import { logout } from '../../../redux/actions/auth';

import { getLinkProps } from '../../../utils';

const AppDropdown = ({ classes, user, learningResources = [] }) => {
  const [open, setOpen] = useState(false);
  const [openUserDropdown, setOpenUserDropdown] = useState(false);
  const [loadImg, setLoadImg] = useState(true);

  const handleDropdownToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleUserDropdownToggle = () => {
    setOpenUserDropdown(!openUserDropdown);
  };

  const handleUserDropdownClose = () => {
    setOpenUserDropdown(false);
  };

  const getUserLinks = links => {
    if (!user || !user.userTeams) return [];
    return links.filter(({ roles = [] }) =>
      roles.length > 0 ? user.userTeams.some(value => roles.includes(value)) : true,
    );
  };

  const renderUserInfo = () => {
    const { fullName, email, img } = user.userInfo;
    return (
      <div className={classes.userInfo}>
        <div className={classes.textInfo}>
          <Typography>{fullName}</Typography>
          <Typography>{email}</Typography>
        </div>
        <div className={classes.user}>
          {loadImg ? <img src={img} onError={() => setLoadImg(!loadImg)} alt="user" /> : <UserIcon title="User icon" />}
        </div>
      </div>
    );
  };

  const renderDropdown = () => (
    <List dense={true} component="div" aria-label="Profile Dropdown" className={classes.links}>
      {getUserLinks([...appDropdownLinks, ...learningResources]).map((link, index) => (
        <ListItem
          key={index}
          {...getLinkProps(link)}
          target={link.targetBlank ? '_blank' : ''}
          onClick={handleUserDropdownClose}
        >
          <ListItemText primary={link.title} />
        </ListItem>
      ))}
    </List>
  );

  const renderLogOutButton = () => {
    return (
      <Button className={classes.logOut} onClick={() => logout()} endIcon={<ArrowRightIcon className={classes.icon} />}>
        Log out
      </Button>
    );
  };

  const renderListDropdownForUser = () => {
    return (
      <div className={classes.dropdown} data-testid="list-dropdown-for-user">
        {renderUserInfo()}
        {renderDropdown()}
        {renderLogOutButton()}
      </div>
    );
  };

  const renderUserDropdown = () => {
    return (
      <ClickAwayListener onClickAway={handleUserDropdownClose}>
        <div className={classes.profile}>
          <Button
            className={classNames(classes.nav)}
            variant="contained"
            disableElevation
            onClick={handleUserDropdownToggle}
            data-testid="user-dropdown-toggle-button"
          >
            <AppsIcon className={classes.icon} title="apps Icon" />
          </Button>
          {openUserDropdown && renderListDropdownForUser()}
        </div>
      </ClickAwayListener>
    );
  };

  const renderLinks = manageLinksForUser => (
    <List className={classes.manageDropdown} component="div" aria-label="Manage Dropdown">
      {manageLinksForUser.map(link => (
        <ListItem key={link.link} button {...getLinkProps(link)} onClick={handleClose}>
          <ListItemText primary={link.title} />
        </ListItem>
      ))}
    </List>
  );

  const renderManageDropdown = manageLinksForUser => {
    return (
      <ClickAwayListener onClickAway={handleClose}>
        <div className={classes.manageDropdownContainer}>
          <Button
            className={classNames(classes.nav, classes.manageDropdownButton, {
              [classes.open]: open,
            })}
            variant="contained"
            disableElevation
            onClick={handleDropdownToggle}
            endIcon={<KeyboardArrowDownIcon />}
          >
            Manage
          </Button>
          {open && renderLinks(manageLinksForUser)}
        </div>
      </ClickAwayListener>
    );
  };

  const manageLinksForUser = getUserLinks([...manageDropdownLinks]);

  return (
    <div className={classes.root}>
      {manageLinksForUser.length > 0 && renderManageDropdown(manageLinksForUser)}
      {renderUserDropdown()}
    </div>
  );
};

export default withStyles(styles(muiTheme))(AppDropdown);
